<template>
  <div
    v-if="!isIE"
    id="app"
    class="jade pagarme"
  >
    <delinquent v-if="blockAccess" />
    <global-loader v-show="isLoading && !hasError && !blockAccess" />
    <div
      v-if="!isLoading && hasError && !blockAccess"
      class="stone-rebrand-error"
    >
      <logo-stone-rebrand class="stone-rebrand-error__logo" />
      <global-error
        :showLogo="false"
        :code="errorCode"
        :theme="theme"
      />
    </div>
    <template v-else-if="!isLoading && !hasError && !blockAccess">
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view />
      </transition>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { GlobalError } from 'emerald-vue/src/components'
import { setDateLocale } from '@/filters'
import { applyThemeOnBody } from '@/support/toggleThemeMode'
import { toStoneBrand } from '@/utils/stone-rebrand.utils'
import LogoStoneRebrand from '@/components/emerald/atoms/LogoStoneRebrand.vue'
import GlobalLoader from './components/project/globals/GlobalLoader'
import Delinquent from './components/project/globals/Delinquent'

export default {
  name: 'App',
  components: {
    GlobalLoader,
    GlobalError,
    Delinquent,
    LogoStoneRebrand
  },
  data () {
    return {
      delinquentAllowedRoutes: ['invoices', 'invoices-detail'],
      theme: process.env.VUE_APP_THEME
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'globalLoading',
      hasError: 'globalError',
      appVersion: 'appVersion',
      merchantDelinquent: 'merchantDelinquent',
      merchantActive: 'merchantActive',
      isEmployee: 'isEmployee',
      pref: 'pref'
    }),
    isIE () {
      return window.isIE
    },
    blockAccess () {
      return (
        this.merchantDelinquent &&
        this.$route.name &&
        !this.delinquentAllowedRoutes.includes(this.$route.name) &&
        !this.isEmployee
      )
    },
    errorCode () {
      return this.$store.state.globalErrorCode
    }
  },
  watch: {
    $route (to, from) {
      const routeTitle = `meta.pageTitle.${to.name}`
      this.$nextTick().then(() => {
        const appTitle = toStoneBrand(process.env.VUE_APP_TITLE)
        document.title = `${this.merchantActive.name} | ${this.$t(
          routeTitle
        )} - ${appTitle}`
      })
    }
  },
  beforeMount () {
    applyThemeOnBody()
    this.$i18n.locale = this.pref.language
    this.setLanguage()
  },
  mounted () {
    var meta = document.createElement('meta')
    meta.name = 'version'
    meta.content = this.appVersion
    document.getElementsByTagName('head')[0].appendChild(meta)
  },
  methods: {
    ...mapActions({
      setPreferemces: 'SET_PREFERENCES'
    }),
    componentIsEnabled (section, component) {
      return this.$store.getters.componentIsEnabled(section, component)
    },
    setLanguage () {
      const preferences = this.pref
      preferences.language = this.$i18n.locale
      setDateLocale(this.$i18n.locale)
      this.setPreferemces(preferences)
    }
  }
}
</script>

<style>
/* show underline on links inside tables */
tr:hover .emd-link {
  text-decoration: underline;
}

#atlwdg-trigger {
  background: var(--brand--le--primary-color--base);
  color: #fff !important;
  border: none;
  box-shadow: none;
  border-radius: 4px 0 0 0;
  text-transform: uppercase;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 11px;
  padding: 6px 12px;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 300ms;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* stone-rebrand: overlay the Stone logo at the top of the error screen when the flag is on */
.stone-rebrand-error {
  position: relative;
}
.stone-rebrand-error__logo {
  position: absolute;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  height: 32px;
  width: auto;
  z-index: 1;
}
</style>
